import { Box, Tabs, Tab } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useAppSelector } from "src/hooks";
import { getRestakingRecords } from "src/slices/AccountSlice";
import { useWeb3Context } from "src/hooks/web3Context";
import { t, Trans } from "@lingui/macro";
import RestakeTable from "src/components/Record/RestakeTable";
import { useDispatch } from "react-redux";
import logger from "src/utils/logger";
const RestakeRecord = () => {
  const { provider, address, connected, connect, chainID } = useWeb3Context();
  const [tab, setTab] = useState(0);
  const dispatch = useDispatch();
  const restakingPool90Records = useAppSelector(state => {
    return state.account.restakingPool90Records;
  });
  const restakingPool180Records = useAppSelector(state => {
    return state.account.restakingPool180Records;
  });
  const restakingPool360Records = useAppSelector(state => {
    return state.account.restakingPool360Records;
  });
  const restaking90Paused = useAppSelector(state => {
    return state.account.restaking90Paused;
  });
  const restaking180Paused = useAppSelector(state => {
    return state.account.restaking180Paused;
  });
  const restaking360Paused = useAppSelector(state => {
    return state.account.restaking360Paused;
  });
  // console.log("restaking90Paused", restaking90Paused);
  // console.log("restaking180Paused", restaking180Paused);
  // console.log("restaking360Paused", restaking360Paused);
  const changeTab = (_event: React.ChangeEvent<{}>, newTab: number) => {
    setTab(newTab);
  };
  useEffect(() => {
    if (address) {
      logger.info("useWeb3Context RestakeRecord", { address, chainID, provider });
      dispatch(getRestakingRecords({ address, networkID: chainID, provider }));
    }
  }, [address, chainID, provider]);
  return (
    <Box>
      {((restakingPool90Records && restakingPool90Records.length >= 0) ||
        (restakingPool180Records && restakingPool180Records.length >= 0) ||
        (restakingPool360Records && restakingPool360Records.length >= 0) ||
        !address) && (
        <Box
          sx={{
            width: "100%",
          }}
        >
          {/* record tab */}
          <Tabs
            sx={{
              borderBottom: "1px solid #2d2d2d",
              mb: {
                xs: "15px",
                sm: "20px",
              },
              "& .MuiTabs-indicator": {
                background: "#fff",
              },
            }}
            value={tab}
            onChange={changeTab}
          >
            <Tab
              label={t`Restaking Record`}
              sx={{
                color: "#848E9C",
                fontSize: { sm: "16px", xs: "14px" },
                fontWeight: "400",
                textTransform: "capitalize",
                "&.Mui-selected": {
                  color: "#EAECEF",
                  fontWeight: "600",
                },
              }}
            />
          </Tabs>
          {/* data */}
          <RestakeTable
            restakingPool90Records={restakingPool90Records}
            restakingPool180Records={restakingPool180Records}
            restakingPool360Records={restakingPool360Records}
            restaking90Paused={restaking90Paused}
            restaking180Paused={restaking180Paused}
            restaking360Paused={restaking360Paused}
          />
        </Box>
      )}
    </Box>
  );
};

export default RestakeRecord;
